export const appInfo = {
    appVersion : '1.1.11',
    appName : 'iPedidos'
}
